import React from "react";
import { useTranslation } from "react-i18next";
import Button from "shared/components/FormElements/Button";
import Modal from "shared/components/UIElements/Modal";
import "./SeedDataConfirmationModal.css";
import { COMPANY_DOMAINS } from "@routebot/constants";

const SeedDataConfirmationModal = ({ show, onAccept, onSkip, isLoading, transportType }) => {
  const { t } = useTranslation();

  return (
    <Modal
      show={show}
      header={t("seedData.title")}
      onCancel={() => {}} // Prevent closing
      footerClass="seed-data-modal-footer"
      footer={
        <div className="seed-data-modal-buttons">
          <Button onClick={onSkip} disabled={isLoading} inverse style={{ marginRight: "1rem" }}>
            {t("seedData.skip")}
          </Button>
          <Button onClick={onAccept} isLoading={isLoading} disabled={isLoading}>
            {t("seedData.loadSampleData")}
          </Button>
        </div>
      }
    >
      <div className="seed-data-modal-content">
        <div className="seed-data-icon">📦</div>

        <p className="seed-data-description">{t("seedData.description")}</p>

        <div className="seed-data-benefits">
          <h4>{t("seedData.whatWillBeLoaded")}</h4>
          <ul>
            <li>
              <span className="benefit-icon">🏫</span>
              {t("seedData.schools")}
            </li>
            {(transportType === COMPANY_DOMAINS.STUDENT || transportType === "both") && (
              <>
                <li>
                  <span className="benefit-icon">👨‍👩‍👧</span>
                  {t("seedData.students")}
                </li>
                <li>
                  <span className="benefit-icon">👤</span>
                  {t("seedData.parents")}
                </li>
              </>
            )}
            {(transportType === COMPANY_DOMAINS.PERSONEL || transportType === "both") && (
              <li>
                <span className="benefit-icon">💼</span>
                {t("seedData.personnel")}
              </li>
            )}
            <li>
              <span className="benefit-icon">🚗</span>
              {t("seedData.drivers")}
            </li>
            <li>
              <span className="benefit-icon">🚌</span>
              {t("seedData.routes")}
            </li>
          </ul>
        </div>

        <div className="seed-data-warning">
          <span className="warning-icon">⚠️</span>
          <div>
            <strong>{t("seedData.warningTitle")}</strong>
            <p>{t("seedData.warningDescription")}</p>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default SeedDataConfirmationModal;
